import { JoeIcmp, Schema } from "../../../../../@types";
import { enums } from "../../../../../../../shim/jsbridge";
import Name from "../../../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const icmp: Schema<JoeIcmp> = {
  fields: [
    {
      name: "timestamp",
      displayTitle: "Timestamp",
      sortable: true,
      component: d => <>{d.timestamp}</>
    },
    {
      name: "srcip",
      displayTitle: "Source IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.srcip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dstip",
      displayTitle: "Destination IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.dstip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "checksum",
      displayTitle: "Checksum",
      sortable: true,
      component: d => <>{d.checksum}</>
    },
    {
      name: "code",
      displayTitle: "Code",
      sortable: true,
      component: d => <>{d.code}</>
    },
    {
      name: "type",
      displayTitle: "Type",
      sortable: true,
      component: d => <>{d.type}</>
    }
  ]
};
